import config from '@config/seo_meta.json'
import cn from 'clsx'
import Image from "next/legacy/image"
import Link from 'next/link'
interface Props {
  slice: any
}
const BannerWithText = ({ slice }: Props) => {
  const { primary } = slice
  const bannerImage = primary?.bannerImage
  const layout = primary?.layout
  const link = primary?.link
  const linkText = primary?.linkText
  const text = primary?.text
  const title = primary?.title
  return (
    <div className="w-full bg-ui-light-grey">
      <div className="relative w-full ">
        <div className="relative h-[375px] w-full lg:h-[810px]">
          <Image
            src={bannerImage?.url || '/product-img-placeholder.svg'}
            alt={bannerImage?.alt || config.openGraph.images[0].alt}
            layout="fill"
            objectFit="cover"
          ></Image>
        </div>
        <div className="absolute left-0 right-0 bottom-0 mx-auto hidden max-w-desktop grid-cols-12 gap-8 lg:grid">
          <div
            className={cn(
              'col-span-6 bg-brand-light-grey pt-12 pb-12',
              { ' pl-16 pr-12 ': !layout },
              { ' col-start-7 pr-16 pl-12': layout }
            )}
          >
            <div className="flex flex-col items-start justify-start gap-4">
              {title && (
                <div className="heading-3 text-brand-dark-grey">{title}</div>
              )}
              {text && (
                <div className="body-1 text-brand-dark-grey">{text}</div>
              )}
              {link && linkText && (
                <div className="body-1 text brand-dark-grey cursor-pointer underline hover:opacity-75">
                  <Link href={link}>
                    {linkText}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="block w-full bg-brand-light-grey pt-8 pb-10 pl-4 pr-4 lg:hidden">
          <div className="flex flex-col items-start justify-start gap-4">
            {title && (
              <div className="heading-mobile-3  text-brand-dark-grey">
                {title}
              </div>
            )}
            {text && <div className="body-1 text-brand-dark-grey">{text}</div>}
            {link && linkText && (
              <div className="body-1 text brand-dark-grey cursor-pointer underline hover:opacity-75">
                <Link href={link}>
                  {linkText}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerWithText
